/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SessionExpiredRouteImport } from './routes/session-expired'
import { Route as NoTokenRouteImport } from './routes/no-token'
import { Route as MaintenanceRouteImport } from './routes/maintenance'
import { Route as StudentCoursesCourseIdRouteRouteImport } from './routes/student.courses.$courseId/route'
import { Route as EducatorCoursesCourseIdRouteRouteImport } from './routes/educator.courses.$courseId/route'
import { Route as StudentCoursesCourseIdIndexRouteImport } from './routes/student.courses.$courseId/index'
import { Route as EducatorCoursesCourseIdIndexRouteImport } from './routes/educator.courses.$courseId/index'
import { Route as EducatorCoursesCourseIdDataRouteImport } from './routes/educator.courses.$courseId/data'
import { Route as EducatorCoursesCourseIdAppsIndexRouteImport } from './routes/educator.courses.$courseId/apps.index'
import { Route as StudentCoursesCourseIdTemplatesTemplateIdRouteImport } from './routes/student.courses.$courseId/templates.$templateId'
import { Route as EducatorCoursesCourseIdAppsAppIdRouteImport } from './routes/educator.courses.$courseId/apps.$appId'
import { Route as StudentCoursesCourseIdAppsAppIdIndexRouteImport } from './routes/student.courses.$courseId/apps.$appId.index'
import { Route as EducatorCoursesCourseIdAppsAppIdIndexRouteImport } from './routes/educator.courses.$courseId/apps.$appId.index'
import { Route as EducatorCoursesCourseIdAppsAppIdSourcesRouteImport } from './routes/educator.courses.$courseId/apps.$appId.sources'
import { Route as EducatorCoursesCourseIdAppsAppIdSettingsRouteImport } from './routes/educator.courses.$courseId/apps.$appId.settings'
import { Route as EducatorCoursesCourseIdAppsAppIdPromptRouteImport } from './routes/educator.courses.$courseId/apps.$appId.prompt'
import { Route as EducatorCoursesCourseIdAppsAppIdDetailsRouteImport } from './routes/educator.courses.$courseId/apps.$appId.details'
import { Route as EducatorCoursesCourseIdAppsAppIdAccessRouteImport } from './routes/educator.courses.$courseId/apps.$appId.access'
import { Route as StudentCoursesCourseIdAppsAppIdThreadsThreadIdRouteImport } from './routes/student.courses.$courseId/apps.$appId.threads.$threadId'

const SessionExpiredRoute = SessionExpiredRouteImport.update({
  id: '/session-expired',
  path: '/session-expired',
  getParentRoute: () => rootRouteImport,
} as any)
const NoTokenRoute = NoTokenRouteImport.update({
  id: '/no-token',
  path: '/no-token',
  getParentRoute: () => rootRouteImport,
} as any)
const MaintenanceRoute = MaintenanceRouteImport.update({
  id: '/maintenance',
  path: '/maintenance',
  getParentRoute: () => rootRouteImport,
} as any)
const StudentCoursesCourseIdRouteRoute =
  StudentCoursesCourseIdRouteRouteImport.update({
    id: '/student/courses/$courseId',
    path: '/student/courses/$courseId',
    getParentRoute: () => rootRouteImport,
  } as any)
const EducatorCoursesCourseIdRouteRoute =
  EducatorCoursesCourseIdRouteRouteImport.update({
    id: '/educator/courses/$courseId',
    path: '/educator/courses/$courseId',
    getParentRoute: () => rootRouteImport,
  } as any)
const StudentCoursesCourseIdIndexRoute =
  StudentCoursesCourseIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StudentCoursesCourseIdRouteRoute,
  } as any)
const EducatorCoursesCourseIdIndexRoute =
  EducatorCoursesCourseIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => EducatorCoursesCourseIdRouteRoute,
  } as any)
const EducatorCoursesCourseIdDataRoute =
  EducatorCoursesCourseIdDataRouteImport.update({
    id: '/data',
    path: '/data',
    getParentRoute: () => EducatorCoursesCourseIdRouteRoute,
  } as any)
const EducatorCoursesCourseIdAppsIndexRoute =
  EducatorCoursesCourseIdAppsIndexRouteImport.update({
    id: '/apps/',
    path: '/apps/',
    getParentRoute: () => EducatorCoursesCourseIdRouteRoute,
  } as any)
const StudentCoursesCourseIdTemplatesTemplateIdRoute =
  StudentCoursesCourseIdTemplatesTemplateIdRouteImport.update({
    id: '/templates/$templateId',
    path: '/templates/$templateId',
    getParentRoute: () => StudentCoursesCourseIdRouteRoute,
  } as any)
const EducatorCoursesCourseIdAppsAppIdRoute =
  EducatorCoursesCourseIdAppsAppIdRouteImport.update({
    id: '/apps/$appId',
    path: '/apps/$appId',
    getParentRoute: () => EducatorCoursesCourseIdRouteRoute,
  } as any)
const StudentCoursesCourseIdAppsAppIdIndexRoute =
  StudentCoursesCourseIdAppsAppIdIndexRouteImport.update({
    id: '/apps/$appId/',
    path: '/apps/$appId/',
    getParentRoute: () => StudentCoursesCourseIdRouteRoute,
  } as any)
const EducatorCoursesCourseIdAppsAppIdIndexRoute =
  EducatorCoursesCourseIdAppsAppIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => EducatorCoursesCourseIdAppsAppIdRoute,
  } as any)
const EducatorCoursesCourseIdAppsAppIdSourcesRoute =
  EducatorCoursesCourseIdAppsAppIdSourcesRouteImport.update({
    id: '/sources',
    path: '/sources',
    getParentRoute: () => EducatorCoursesCourseIdAppsAppIdRoute,
  } as any)
const EducatorCoursesCourseIdAppsAppIdSettingsRoute =
  EducatorCoursesCourseIdAppsAppIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => EducatorCoursesCourseIdAppsAppIdRoute,
  } as any)
const EducatorCoursesCourseIdAppsAppIdPromptRoute =
  EducatorCoursesCourseIdAppsAppIdPromptRouteImport.update({
    id: '/prompt',
    path: '/prompt',
    getParentRoute: () => EducatorCoursesCourseIdAppsAppIdRoute,
  } as any)
const EducatorCoursesCourseIdAppsAppIdDetailsRoute =
  EducatorCoursesCourseIdAppsAppIdDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => EducatorCoursesCourseIdAppsAppIdRoute,
  } as any)
const EducatorCoursesCourseIdAppsAppIdAccessRoute =
  EducatorCoursesCourseIdAppsAppIdAccessRouteImport.update({
    id: '/access',
    path: '/access',
    getParentRoute: () => EducatorCoursesCourseIdAppsAppIdRoute,
  } as any)
const StudentCoursesCourseIdAppsAppIdThreadsThreadIdRoute =
  StudentCoursesCourseIdAppsAppIdThreadsThreadIdRouteImport.update({
    id: '/apps/$appId/threads/$threadId',
    path: '/apps/$appId/threads/$threadId',
    getParentRoute: () => StudentCoursesCourseIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/maintenance': typeof MaintenanceRoute
  '/no-token': typeof NoTokenRoute
  '/session-expired': typeof SessionExpiredRoute
  '/educator/courses/$courseId': typeof EducatorCoursesCourseIdRouteRouteWithChildren
  '/student/courses/$courseId': typeof StudentCoursesCourseIdRouteRouteWithChildren
  '/educator/courses/$courseId/data': typeof EducatorCoursesCourseIdDataRoute
  '/educator/courses/$courseId/': typeof EducatorCoursesCourseIdIndexRoute
  '/student/courses/$courseId/': typeof StudentCoursesCourseIdIndexRoute
  '/educator/courses/$courseId/apps/$appId': typeof EducatorCoursesCourseIdAppsAppIdRouteWithChildren
  '/student/courses/$courseId/templates/$templateId': typeof StudentCoursesCourseIdTemplatesTemplateIdRoute
  '/educator/courses/$courseId/apps': typeof EducatorCoursesCourseIdAppsIndexRoute
  '/educator/courses/$courseId/apps/$appId/access': typeof EducatorCoursesCourseIdAppsAppIdAccessRoute
  '/educator/courses/$courseId/apps/$appId/details': typeof EducatorCoursesCourseIdAppsAppIdDetailsRoute
  '/educator/courses/$courseId/apps/$appId/prompt': typeof EducatorCoursesCourseIdAppsAppIdPromptRoute
  '/educator/courses/$courseId/apps/$appId/settings': typeof EducatorCoursesCourseIdAppsAppIdSettingsRoute
  '/educator/courses/$courseId/apps/$appId/sources': typeof EducatorCoursesCourseIdAppsAppIdSourcesRoute
  '/educator/courses/$courseId/apps/$appId/': typeof EducatorCoursesCourseIdAppsAppIdIndexRoute
  '/student/courses/$courseId/apps/$appId': typeof StudentCoursesCourseIdAppsAppIdIndexRoute
  '/student/courses/$courseId/apps/$appId/threads/$threadId': typeof StudentCoursesCourseIdAppsAppIdThreadsThreadIdRoute
}
export interface FileRoutesByTo {
  '/maintenance': typeof MaintenanceRoute
  '/no-token': typeof NoTokenRoute
  '/session-expired': typeof SessionExpiredRoute
  '/educator/courses/$courseId/data': typeof EducatorCoursesCourseIdDataRoute
  '/educator/courses/$courseId': typeof EducatorCoursesCourseIdIndexRoute
  '/student/courses/$courseId': typeof StudentCoursesCourseIdIndexRoute
  '/student/courses/$courseId/templates/$templateId': typeof StudentCoursesCourseIdTemplatesTemplateIdRoute
  '/educator/courses/$courseId/apps': typeof EducatorCoursesCourseIdAppsIndexRoute
  '/educator/courses/$courseId/apps/$appId/access': typeof EducatorCoursesCourseIdAppsAppIdAccessRoute
  '/educator/courses/$courseId/apps/$appId/details': typeof EducatorCoursesCourseIdAppsAppIdDetailsRoute
  '/educator/courses/$courseId/apps/$appId/prompt': typeof EducatorCoursesCourseIdAppsAppIdPromptRoute
  '/educator/courses/$courseId/apps/$appId/settings': typeof EducatorCoursesCourseIdAppsAppIdSettingsRoute
  '/educator/courses/$courseId/apps/$appId/sources': typeof EducatorCoursesCourseIdAppsAppIdSourcesRoute
  '/educator/courses/$courseId/apps/$appId': typeof EducatorCoursesCourseIdAppsAppIdIndexRoute
  '/student/courses/$courseId/apps/$appId': typeof StudentCoursesCourseIdAppsAppIdIndexRoute
  '/student/courses/$courseId/apps/$appId/threads/$threadId': typeof StudentCoursesCourseIdAppsAppIdThreadsThreadIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/maintenance': typeof MaintenanceRoute
  '/no-token': typeof NoTokenRoute
  '/session-expired': typeof SessionExpiredRoute
  '/educator/courses/$courseId': typeof EducatorCoursesCourseIdRouteRouteWithChildren
  '/student/courses/$courseId': typeof StudentCoursesCourseIdRouteRouteWithChildren
  '/educator/courses/$courseId/data': typeof EducatorCoursesCourseIdDataRoute
  '/educator/courses/$courseId/': typeof EducatorCoursesCourseIdIndexRoute
  '/student/courses/$courseId/': typeof StudentCoursesCourseIdIndexRoute
  '/educator/courses/$courseId/apps/$appId': typeof EducatorCoursesCourseIdAppsAppIdRouteWithChildren
  '/student/courses/$courseId/templates/$templateId': typeof StudentCoursesCourseIdTemplatesTemplateIdRoute
  '/educator/courses/$courseId/apps/': typeof EducatorCoursesCourseIdAppsIndexRoute
  '/educator/courses/$courseId/apps/$appId/access': typeof EducatorCoursesCourseIdAppsAppIdAccessRoute
  '/educator/courses/$courseId/apps/$appId/details': typeof EducatorCoursesCourseIdAppsAppIdDetailsRoute
  '/educator/courses/$courseId/apps/$appId/prompt': typeof EducatorCoursesCourseIdAppsAppIdPromptRoute
  '/educator/courses/$courseId/apps/$appId/settings': typeof EducatorCoursesCourseIdAppsAppIdSettingsRoute
  '/educator/courses/$courseId/apps/$appId/sources': typeof EducatorCoursesCourseIdAppsAppIdSourcesRoute
  '/educator/courses/$courseId/apps/$appId/': typeof EducatorCoursesCourseIdAppsAppIdIndexRoute
  '/student/courses/$courseId/apps/$appId/': typeof StudentCoursesCourseIdAppsAppIdIndexRoute
  '/student/courses/$courseId/apps/$appId/threads/$threadId': typeof StudentCoursesCourseIdAppsAppIdThreadsThreadIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/maintenance'
    | '/no-token'
    | '/session-expired'
    | '/educator/courses/$courseId'
    | '/student/courses/$courseId'
    | '/educator/courses/$courseId/data'
    | '/educator/courses/$courseId/'
    | '/student/courses/$courseId/'
    | '/educator/courses/$courseId/apps/$appId'
    | '/student/courses/$courseId/templates/$templateId'
    | '/educator/courses/$courseId/apps'
    | '/educator/courses/$courseId/apps/$appId/access'
    | '/educator/courses/$courseId/apps/$appId/details'
    | '/educator/courses/$courseId/apps/$appId/prompt'
    | '/educator/courses/$courseId/apps/$appId/settings'
    | '/educator/courses/$courseId/apps/$appId/sources'
    | '/educator/courses/$courseId/apps/$appId/'
    | '/student/courses/$courseId/apps/$appId'
    | '/student/courses/$courseId/apps/$appId/threads/$threadId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/maintenance'
    | '/no-token'
    | '/session-expired'
    | '/educator/courses/$courseId/data'
    | '/educator/courses/$courseId'
    | '/student/courses/$courseId'
    | '/student/courses/$courseId/templates/$templateId'
    | '/educator/courses/$courseId/apps'
    | '/educator/courses/$courseId/apps/$appId/access'
    | '/educator/courses/$courseId/apps/$appId/details'
    | '/educator/courses/$courseId/apps/$appId/prompt'
    | '/educator/courses/$courseId/apps/$appId/settings'
    | '/educator/courses/$courseId/apps/$appId/sources'
    | '/educator/courses/$courseId/apps/$appId'
    | '/student/courses/$courseId/apps/$appId'
    | '/student/courses/$courseId/apps/$appId/threads/$threadId'
  id:
    | '__root__'
    | '/maintenance'
    | '/no-token'
    | '/session-expired'
    | '/educator/courses/$courseId'
    | '/student/courses/$courseId'
    | '/educator/courses/$courseId/data'
    | '/educator/courses/$courseId/'
    | '/student/courses/$courseId/'
    | '/educator/courses/$courseId/apps/$appId'
    | '/student/courses/$courseId/templates/$templateId'
    | '/educator/courses/$courseId/apps/'
    | '/educator/courses/$courseId/apps/$appId/access'
    | '/educator/courses/$courseId/apps/$appId/details'
    | '/educator/courses/$courseId/apps/$appId/prompt'
    | '/educator/courses/$courseId/apps/$appId/settings'
    | '/educator/courses/$courseId/apps/$appId/sources'
    | '/educator/courses/$courseId/apps/$appId/'
    | '/student/courses/$courseId/apps/$appId/'
    | '/student/courses/$courseId/apps/$appId/threads/$threadId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  MaintenanceRoute: typeof MaintenanceRoute
  NoTokenRoute: typeof NoTokenRoute
  SessionExpiredRoute: typeof SessionExpiredRoute
  EducatorCoursesCourseIdRouteRoute: typeof EducatorCoursesCourseIdRouteRouteWithChildren
  StudentCoursesCourseIdRouteRoute: typeof StudentCoursesCourseIdRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/session-expired': {
      id: '/session-expired'
      path: '/session-expired'
      fullPath: '/session-expired'
      preLoaderRoute: typeof SessionExpiredRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/no-token': {
      id: '/no-token'
      path: '/no-token'
      fullPath: '/no-token'
      preLoaderRoute: typeof NoTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/maintenance': {
      id: '/maintenance'
      path: '/maintenance'
      fullPath: '/maintenance'
      preLoaderRoute: typeof MaintenanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/student/courses/$courseId': {
      id: '/student/courses/$courseId'
      path: '/student/courses/$courseId'
      fullPath: '/student/courses/$courseId'
      preLoaderRoute: typeof StudentCoursesCourseIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/educator/courses/$courseId': {
      id: '/educator/courses/$courseId'
      path: '/educator/courses/$courseId'
      fullPath: '/educator/courses/$courseId'
      preLoaderRoute: typeof EducatorCoursesCourseIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/student/courses/$courseId/': {
      id: '/student/courses/$courseId/'
      path: '/'
      fullPath: '/student/courses/$courseId/'
      preLoaderRoute: typeof StudentCoursesCourseIdIndexRouteImport
      parentRoute: typeof StudentCoursesCourseIdRouteRoute
    }
    '/educator/courses/$courseId/': {
      id: '/educator/courses/$courseId/'
      path: '/'
      fullPath: '/educator/courses/$courseId/'
      preLoaderRoute: typeof EducatorCoursesCourseIdIndexRouteImport
      parentRoute: typeof EducatorCoursesCourseIdRouteRoute
    }
    '/educator/courses/$courseId/data': {
      id: '/educator/courses/$courseId/data'
      path: '/data'
      fullPath: '/educator/courses/$courseId/data'
      preLoaderRoute: typeof EducatorCoursesCourseIdDataRouteImport
      parentRoute: typeof EducatorCoursesCourseIdRouteRoute
    }
    '/educator/courses/$courseId/apps/': {
      id: '/educator/courses/$courseId/apps/'
      path: '/apps'
      fullPath: '/educator/courses/$courseId/apps'
      preLoaderRoute: typeof EducatorCoursesCourseIdAppsIndexRouteImport
      parentRoute: typeof EducatorCoursesCourseIdRouteRoute
    }
    '/student/courses/$courseId/templates/$templateId': {
      id: '/student/courses/$courseId/templates/$templateId'
      path: '/templates/$templateId'
      fullPath: '/student/courses/$courseId/templates/$templateId'
      preLoaderRoute: typeof StudentCoursesCourseIdTemplatesTemplateIdRouteImport
      parentRoute: typeof StudentCoursesCourseIdRouteRoute
    }
    '/educator/courses/$courseId/apps/$appId': {
      id: '/educator/courses/$courseId/apps/$appId'
      path: '/apps/$appId'
      fullPath: '/educator/courses/$courseId/apps/$appId'
      preLoaderRoute: typeof EducatorCoursesCourseIdAppsAppIdRouteImport
      parentRoute: typeof EducatorCoursesCourseIdRouteRoute
    }
    '/student/courses/$courseId/apps/$appId/': {
      id: '/student/courses/$courseId/apps/$appId/'
      path: '/apps/$appId'
      fullPath: '/student/courses/$courseId/apps/$appId'
      preLoaderRoute: typeof StudentCoursesCourseIdAppsAppIdIndexRouteImport
      parentRoute: typeof StudentCoursesCourseIdRouteRoute
    }
    '/educator/courses/$courseId/apps/$appId/': {
      id: '/educator/courses/$courseId/apps/$appId/'
      path: '/'
      fullPath: '/educator/courses/$courseId/apps/$appId/'
      preLoaderRoute: typeof EducatorCoursesCourseIdAppsAppIdIndexRouteImport
      parentRoute: typeof EducatorCoursesCourseIdAppsAppIdRoute
    }
    '/educator/courses/$courseId/apps/$appId/sources': {
      id: '/educator/courses/$courseId/apps/$appId/sources'
      path: '/sources'
      fullPath: '/educator/courses/$courseId/apps/$appId/sources'
      preLoaderRoute: typeof EducatorCoursesCourseIdAppsAppIdSourcesRouteImport
      parentRoute: typeof EducatorCoursesCourseIdAppsAppIdRoute
    }
    '/educator/courses/$courseId/apps/$appId/settings': {
      id: '/educator/courses/$courseId/apps/$appId/settings'
      path: '/settings'
      fullPath: '/educator/courses/$courseId/apps/$appId/settings'
      preLoaderRoute: typeof EducatorCoursesCourseIdAppsAppIdSettingsRouteImport
      parentRoute: typeof EducatorCoursesCourseIdAppsAppIdRoute
    }
    '/educator/courses/$courseId/apps/$appId/prompt': {
      id: '/educator/courses/$courseId/apps/$appId/prompt'
      path: '/prompt'
      fullPath: '/educator/courses/$courseId/apps/$appId/prompt'
      preLoaderRoute: typeof EducatorCoursesCourseIdAppsAppIdPromptRouteImport
      parentRoute: typeof EducatorCoursesCourseIdAppsAppIdRoute
    }
    '/educator/courses/$courseId/apps/$appId/details': {
      id: '/educator/courses/$courseId/apps/$appId/details'
      path: '/details'
      fullPath: '/educator/courses/$courseId/apps/$appId/details'
      preLoaderRoute: typeof EducatorCoursesCourseIdAppsAppIdDetailsRouteImport
      parentRoute: typeof EducatorCoursesCourseIdAppsAppIdRoute
    }
    '/educator/courses/$courseId/apps/$appId/access': {
      id: '/educator/courses/$courseId/apps/$appId/access'
      path: '/access'
      fullPath: '/educator/courses/$courseId/apps/$appId/access'
      preLoaderRoute: typeof EducatorCoursesCourseIdAppsAppIdAccessRouteImport
      parentRoute: typeof EducatorCoursesCourseIdAppsAppIdRoute
    }
    '/student/courses/$courseId/apps/$appId/threads/$threadId': {
      id: '/student/courses/$courseId/apps/$appId/threads/$threadId'
      path: '/apps/$appId/threads/$threadId'
      fullPath: '/student/courses/$courseId/apps/$appId/threads/$threadId'
      preLoaderRoute: typeof StudentCoursesCourseIdAppsAppIdThreadsThreadIdRouteImport
      parentRoute: typeof StudentCoursesCourseIdRouteRoute
    }
  }
}

interface EducatorCoursesCourseIdAppsAppIdRouteChildren {
  EducatorCoursesCourseIdAppsAppIdAccessRoute: typeof EducatorCoursesCourseIdAppsAppIdAccessRoute
  EducatorCoursesCourseIdAppsAppIdDetailsRoute: typeof EducatorCoursesCourseIdAppsAppIdDetailsRoute
  EducatorCoursesCourseIdAppsAppIdPromptRoute: typeof EducatorCoursesCourseIdAppsAppIdPromptRoute
  EducatorCoursesCourseIdAppsAppIdSettingsRoute: typeof EducatorCoursesCourseIdAppsAppIdSettingsRoute
  EducatorCoursesCourseIdAppsAppIdSourcesRoute: typeof EducatorCoursesCourseIdAppsAppIdSourcesRoute
  EducatorCoursesCourseIdAppsAppIdIndexRoute: typeof EducatorCoursesCourseIdAppsAppIdIndexRoute
}

const EducatorCoursesCourseIdAppsAppIdRouteChildren: EducatorCoursesCourseIdAppsAppIdRouteChildren =
  {
    EducatorCoursesCourseIdAppsAppIdAccessRoute:
      EducatorCoursesCourseIdAppsAppIdAccessRoute,
    EducatorCoursesCourseIdAppsAppIdDetailsRoute:
      EducatorCoursesCourseIdAppsAppIdDetailsRoute,
    EducatorCoursesCourseIdAppsAppIdPromptRoute:
      EducatorCoursesCourseIdAppsAppIdPromptRoute,
    EducatorCoursesCourseIdAppsAppIdSettingsRoute:
      EducatorCoursesCourseIdAppsAppIdSettingsRoute,
    EducatorCoursesCourseIdAppsAppIdSourcesRoute:
      EducatorCoursesCourseIdAppsAppIdSourcesRoute,
    EducatorCoursesCourseIdAppsAppIdIndexRoute:
      EducatorCoursesCourseIdAppsAppIdIndexRoute,
  }

const EducatorCoursesCourseIdAppsAppIdRouteWithChildren =
  EducatorCoursesCourseIdAppsAppIdRoute._addFileChildren(
    EducatorCoursesCourseIdAppsAppIdRouteChildren,
  )

interface EducatorCoursesCourseIdRouteRouteChildren {
  EducatorCoursesCourseIdDataRoute: typeof EducatorCoursesCourseIdDataRoute
  EducatorCoursesCourseIdIndexRoute: typeof EducatorCoursesCourseIdIndexRoute
  EducatorCoursesCourseIdAppsAppIdRoute: typeof EducatorCoursesCourseIdAppsAppIdRouteWithChildren
  EducatorCoursesCourseIdAppsIndexRoute: typeof EducatorCoursesCourseIdAppsIndexRoute
}

const EducatorCoursesCourseIdRouteRouteChildren: EducatorCoursesCourseIdRouteRouteChildren =
  {
    EducatorCoursesCourseIdDataRoute: EducatorCoursesCourseIdDataRoute,
    EducatorCoursesCourseIdIndexRoute: EducatorCoursesCourseIdIndexRoute,
    EducatorCoursesCourseIdAppsAppIdRoute:
      EducatorCoursesCourseIdAppsAppIdRouteWithChildren,
    EducatorCoursesCourseIdAppsIndexRoute:
      EducatorCoursesCourseIdAppsIndexRoute,
  }

const EducatorCoursesCourseIdRouteRouteWithChildren =
  EducatorCoursesCourseIdRouteRoute._addFileChildren(
    EducatorCoursesCourseIdRouteRouteChildren,
  )

interface StudentCoursesCourseIdRouteRouteChildren {
  StudentCoursesCourseIdIndexRoute: typeof StudentCoursesCourseIdIndexRoute
  StudentCoursesCourseIdTemplatesTemplateIdRoute: typeof StudentCoursesCourseIdTemplatesTemplateIdRoute
  StudentCoursesCourseIdAppsAppIdIndexRoute: typeof StudentCoursesCourseIdAppsAppIdIndexRoute
  StudentCoursesCourseIdAppsAppIdThreadsThreadIdRoute: typeof StudentCoursesCourseIdAppsAppIdThreadsThreadIdRoute
}

const StudentCoursesCourseIdRouteRouteChildren: StudentCoursesCourseIdRouteRouteChildren =
  {
    StudentCoursesCourseIdIndexRoute: StudentCoursesCourseIdIndexRoute,
    StudentCoursesCourseIdTemplatesTemplateIdRoute:
      StudentCoursesCourseIdTemplatesTemplateIdRoute,
    StudentCoursesCourseIdAppsAppIdIndexRoute:
      StudentCoursesCourseIdAppsAppIdIndexRoute,
    StudentCoursesCourseIdAppsAppIdThreadsThreadIdRoute:
      StudentCoursesCourseIdAppsAppIdThreadsThreadIdRoute,
  }

const StudentCoursesCourseIdRouteRouteWithChildren =
  StudentCoursesCourseIdRouteRoute._addFileChildren(
    StudentCoursesCourseIdRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  MaintenanceRoute: MaintenanceRoute,
  NoTokenRoute: NoTokenRoute,
  SessionExpiredRoute: SessionExpiredRoute,
  EducatorCoursesCourseIdRouteRoute:
    EducatorCoursesCourseIdRouteRouteWithChildren,
  StudentCoursesCourseIdRouteRoute:
    StudentCoursesCourseIdRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
